module.exports = __webpack_public_path__ + "assets/img/30_782.0541da59.jpg";